import { createApp } from 'vue'
import App from './App.vue'
/* vue-i18n */
// 1. npm install vue-i18n
import i18n from './plugins/i18n'
import router from './router'

/* FontAwesome */
// 1. 先安裝以下三個
// npm i --save @fortawesome/fontawesome-svg-core
// npm i --save @fortawesome/free-solid-svg-icons，如果要品牌icon安裝：npm i --save @fortawesome/free-brands-svg-icons
// Using Vue 2.x：npm i --save @fortawesome/vue-fontawesome@latest || Using Vue 3.x：npm i --save @fortawesome/vue-fontawesome@prerelease
// 2. 在import以下
import { library } from '@fortawesome/fontawesome-svg-core'
// 要用的符號要這邊一個一個import
import { faAngleDown, faComment, faChartBar, faNoteSticky, faCamera, faLink } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faTwitterSquare, faYoutubeSquare, faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faFacebookSquare, faTwitterSquare, faYoutubeSquare, faInstagramSquare, faAngleDown, faComment, faChartBar, faNoteSticky, faCamera, faLink)

/* highcharts 全域註冊 */
// 1. npm install highcharts-vue 跟 npm install highcharts
// 2. 加上下面 import... 跟 app.use...
// import HighchartsVue from 'highcharts-vue' 但我用區域註冊就好

import store from './store'

const app = createApp(App);
app.use(store);
// app.use(HighchartsVue);

/* vue-i18n */
app.use(i18n);
app.use(router);

/* FontAwesome */
app.component('font-awesome-icon', FontAwesomeIcon); // 3. 全域註冊font-awesome-icon組件 //4. 最後在去你要放這icon的檔案寫<font-awesome-icon :icon="['fas', 'angle-up']"/>類似這樣的語法

app.mount('#app');
